import { Component, ElementRef, TemplateRef, input, output, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { lucidePlus } from '@ng-icons/lucide';
import { HlmIcon } from '../../../ui/icon/src';
import { HlmButton } from '../../../ui/button/src';

@Component({
  selector: 'app-image-uploader',
  template: `
    <form enctype="multipart/form-data" class="row justify-content-center">
      <section class="col-6 mt-3">
        <div class="d-flex justify-content-center">
          <input #uploader type="file" hidden accept="image/*" (change)="onFileChange($event)" />

          <div class="d-flex justify-content-center">
            <div
              class="my-2"
              id="img-container"
              [style.maxHeight]="imgMaxHeight() + 'px'"
              [style.maxWidth]="imgMaxWidth() + 'px'">
              <img [src]="image()" alt="Upload image" />
              <div class="overlay d-flex justify-content-center align-items-center">
                <div class="action">
                  <button hlmBtn variant="ghost" size="icon" (click)="openPicker()">
                    <ng-icon hlm name="lucidePlus" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </form>
  `,
  styleUrls: ['./image-uploader.component.scss'],
  imports: [FormsModule, HlmButton, NgIcon, HlmIcon],
  providers: [provideIcons({ lucidePlus })],
})
export class ImageUploaderComponent {
  readonly imgMaxWidth = input<number>(200);

  readonly imgMaxHeight = input<number>(200);

  readonly showPreview = input<boolean>(false);

  readonly image = input.required<any>();

  readonly imageChange = output<File>();

  readonly uploader = viewChild.required('uploader', { read: ElementRef });

  readonly outOfBoundsTpl = viewChild.required('outOfBoundsTpl', { read: TemplateRef });

  constructor() {}

  onFileChange(data: Event) {
    const element = data.currentTarget as HTMLInputElement;
    const fileList: FileList | null = element.files;
    if (fileList) {
      const img = fileList[0];
      this.saveImageIfInBoudns(img);
    }
  }

  openPicker() {
    this.uploader().nativeElement.click();
  }

  // private displayPreview() {
  //   if (this.image) {
  //     this.preview.clear();
  //     this.preview.createEmbeddedView(this.imgTpl, {
  //       $implicit: this.image,
  //     });
  //   }
  // }

  private saveImageIfInBoudns(file: File): void {
    const reader = new FileReader();

    reader.onload = (e: any) => {
      const image = new Image();
      image.src = e.target.result;
      image.onload = (rs: any) => {
        // const img_height = rs.currentTarget['height'];
        // const img_width = rs.currentTarget['width'];
        this.imageChange.emit(file);

        // if (img_height < maxHeight && img_width < maxWidth) {
        //   this.imageChange.emit(file);
        //   this.currentImage = file;
        // } else {
        //   this.dialog.open(this.outOfBoundsTpl, {
        //     data: {
        //       maxWidth,
        //       maxHeight,
        //     },
        //   });
        //   console.log('Image is out of bounds...');
        // }
      };
    };
    reader.readAsDataURL(file);
  }
}
